import { CustomFilterValue } from '@ag-table-lib/filters/default-custom-filter.component'
import { getUniqueItems } from '@ag-table-lib/util/getUniqueItems.util'

export const generateStringOptions = (
    stringValues: (string | undefined)[],
    placeholder = '-'
): CustomFilterValue[] =>
    getUniqueItems(
        stringValues.sort().map(
            (value) =>
                ({
                    label: value ?? placeholder,
                    value,
                }) as CustomFilterValue
        )
    )
